/**
 * @author: liaojianming
 * @date 2019-02-18
 * @description: MessageBox消息提示
*/

import {MessageBox} from 'element-ui';

export default {
    confirm: function(message, title, type, confirm, cancel) {
        MessageBox.confirm(message, title, {
            closeOnClickModal: false,
            type: type
        }).then(() => {
            confirm && confirm();
        }).catch(() => {
            cancel && cancel();
        });
    },
    alert: function(message, title, type, callBack) {
        MessageBox.alert(message, title, {
            closeOnClickModal: false,
            type: type
        }).then(() => {
            callBack && callBack();
        }).catch(() => {
            console.log('取消');
        })
    },
    prompt: function(message, title, confirm, cancel) {
        MessageBox.prompt(message, title, {
            closeOnClickModal: false
        }).then(() => {
            confirm && confirm();
        }).catch(() => {
            cancel && cancel();
        })
    }
}